import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    env: null,
    serverLoc: null,

  },
  mutations: {
    setEnv(state, env) {
      state.env = env
      if (env === 'test') {
        state.serverLoc = "https://skmcpanel.smartkidsmarket-test.com"

      } else if (env === 'prod') {
        state.serverLoc = "https://skmcpanel.smartkidsmarket.com"

      } else {
        throw Error("Invalid env in setEnv: "+env)
      }
    }
  },
  actions: {

  }
})
